import { Expose, Type } from 'class-transformer';
import { Model } from '../../shared-features/models/model';

export class ShipmentReport extends Model {
    @Expose() id: number;
    @Expose() createdAt: string;
    @Expose() from: string;
    @Expose() to: string;
    @Expose() mobileNumber: number;
    @Expose() createdBy: string;
    @Expose() iqamaId: number;
    @Expose() truckType: string;
    @Expose() customerName: string;
    @Expose() status: string;
    @Expose() driverName: number;
    @Expose() cost: number;
    @Expose() price: number;
    @Expose() margin: number;
}

export class ShipmentReportWithCount extends Model {
    @Expose()
    @Type(() => ShipmentReport)
    data: ShipmentReport[];

    @Expose() count: number;
}
